import { render, staticRenderFns } from "./TwoStepModal.vue?vue&type=template&id=58f838e0&scoped=true"
import script from "./TwoStepModal.vue?vue&type=script&lang=js"
export * from "./TwoStepModal.vue?vue&type=script&lang=js"
import style0 from "./TwoStepModal.vue?vue&type=style&index=0&id=58f838e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f838e0",
  null
  
)

export default component.exports